import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import ButtonSpinner from "../../../../components/Buttons/ButtonSpinner";

export default function HasEventForm({
  plusXMiceId,
  setPlusXMiceId,
  tryActiveAccreditation,
}) {
  if (!plusXMiceId) {
    return null;
  }
  return (
    <div style={{ paddingBottom: '10px' }}>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <div>
            <Label htmlFor="formFile" className="form-label">
              {`Em qual evento do Mice está a base de dados?`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={plusXMiceId.miceId}
              onChange={(e) => setPlusXMiceId({ ...plusXMiceId, miceId: e.target.value })}
            />
          </div>
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <FormGroup switch>
            <Input
              className="form-control"
              type="switch"
              checked={plusXMiceId.active}
              onChange={(e) => tryActiveAccreditation()}
            />
            <Label htmlFor="formFile" className="form-label">
              {`Ativar Credenciamento`}
            </Label>
          </FormGroup>
        </Col>
      </Row>
    </div>
  )
}
